module.exports = __webpack_public_path__ + "static/media/gotech.3a1f1b8a.jpg";